import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { WorkforceService } from 'src/app/services/workforce.service';
import { ContactsService } from 'src/app/services/contacts.service';
import { AccountsService } from 'src/app/services/accounts.service';
import { Account, AccountPublicInfo } from 'globals/store/accounts.data';
import { WFWorker } from 'src/app/store/events.era';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatButtonModule } from '@angular/material/button';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'add-workforce-to-contacts-dialog',
    template: `
  <div class="add-workforce-to-contacts-dialog joi-dialog">
      <div mat-dialog-title>Add to Contacts</div>
      <div mat-dialog-content>
          <div class="label" [innerHTML]="title"></div>
          <div class="acc" *ngFor="let acc of availableAccounts">
              <div class="name">
                  <mat-checkbox color="primary" (change)="selectAccount($event, acc.id)" >{{acc.title}}</mat-checkbox>
              </div>
          </div>
      </div>
      <div mat-dialog-actions>
          <div style="flex:1;"></div>
          <button mat-button (click)="dialogRef.close()">CANCEL</button>
          <button mat-button color="primary" [disabled]="!selectedAccountIds.size" (click)="saveContacts()" tabindex="1">Add</button>
      </div>
  </div>
  `,
    styleUrls: [`./workforce.main.scss`],
    standalone: true,
    imports: [MatCheckboxModule, MatDialogModule, MatButtonModule, CommonModule]
})
/***
 * This dialog does not close until the call to update the contacts in the firebase database is actually complete
 */
export class AddWorkforceToContactsDialogComponent {


  title = '';
  selectedAccountIds = new Set()
  availableAccounts: AccountPublicInfo[] = []
  constructor(public dialogRef: MatDialogRef<AddWorkforceToContactsDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: AddWorkforceToContactsData, public contacts: ContactsService) {

    const { availableAccounts, workers } = data
    this.availableAccounts = availableAccounts
    if (data.workers.length === 1) {
      const { firstName, lastName, email } = workers[0]
      this.title = `Add <b> ${firstName} ${lastName} </b> (${email}) to:`
    } else {
      this.title = 'Add ' + workers.length + ' selected workforce members to:';
    }

  }
  selectAccount(evt, id) {
    if (this.selectedAccountIds.has(id)) {
      this.selectedAccountIds.delete(id)
    } else {
      this.selectedAccountIds.add(id)
    }
  }
  saveContacts() {
    this.contacts.addMultipleToContacts(this.data.workers, this.availableAccounts.map(a => a.id).filter(id => this.selectedAccountIds.has(id))).then(() => this.dialogRef.close('success'));
  }

}


export interface AddWorkforceToContactsData { 
  workers: WFWorker[]
  availableAccounts: AccountPublicInfo[]
} 